import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { ECommerce, Wishlist } from "../../../../Constants/Constants";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { WishlistData } from "./WishlistData";
import { Fragment } from "react/jsx-runtime";

const WishlistContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={Wishlist} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={Wishlist} />
              <CardBody>
                <WishlistData />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default WishlistContainer;
